import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Countdown, CountdownProps } from '@/components/Countdown';
import { TournamentMode } from '@/helpers/tournaments';

import { ScCountdownTournament, ScCountdownTournamentProps } from './styled';

type CountdownTournamentProps = ScCountdownTournamentProps &
  Pick<CountdownProps, 'timeLeft'>;

export const CountdownTournament: FC<CountdownTournamentProps> = ({
  mode,
  timeLeft,
}) => {
  const { t } = useTranslation();

  const labelTextMap = {
    [TournamentMode.ACTIVE]: 'common:active',
    [TournamentMode.COMING_SOON]: 'common:startIn',
    [TournamentMode.FINISHED]: 'common:finished',
  };

  return (
    <ScCountdownTournament mode={mode}>
      {mode ? (
        <>
          <div className="label">{t(labelTextMap[mode])}</div>
          {mode !== TournamentMode.FINISHED && (
            <div className="countdown">
              <Countdown timeLeft={timeLeft} dual>
                {({ days, hours, minutes, seconds }) => (
                  <>
                    <span attr-label={t('timer.dd')}>{days}</span>:
                    <span attr-label={t('timer.hh')}>{hours}</span>:
                    <span attr-label={t('timer.mm')}>{minutes}</span>:
                    <span attr-label={t('timer.ss')}>{seconds}</span>
                  </>
                )}
              </Countdown>
            </div>
          )}
        </>
      ) : (
        <Countdown timeLeft={timeLeft} dual>
          {({ days, hours, minutes, seconds }) => (
            <div className="timer">
              <div>
                <span>
                  <span className="value">{days}</span>
                  <span>{t('timer.dd')[0]}</span>
                </span>
                <span>:</span>

                <span>
                  <span className="value">{hours}</span>
                  <span>{t('timer.hh')[0]}</span>
                </span>
                <span>:</span>

                <span>
                  <span className="value">{minutes}</span>
                  <span>{t('timer.mm')[0]}</span>
                </span>
                <span>:</span>

                <span>
                  <span className="value">{seconds}</span>
                  <span>{t('timer.ss')[0]}</span>
                </span>
              </div>
              <div className="text">{t('tournaments.untilFinish')}</div>
            </div>
          )}
        </Countdown>
      )}
    </ScCountdownTournament>
  );
};
